import {Injectable} from '@angular/core';
import {forkJoin, Observable} from 'rxjs';
import {map, mergeMap} from 'rxjs/operators';
import {CmsService} from '../modules/cms/services/cms.service';
import {TemplateTypes} from '../modules/shared/models/template-types.enum';
import {CompilerService} from '../modules/shared/services/compiler.service';
import {TemplatesService} from '../modules/shared/services/templates.service';
import {ProjectService} from '../modules/shared/services/project.service';
import {IRemoteProfile} from '../modules/shared/interfaces/iremote-profile';
import {Agenzia} from '../modules/pages/store-locator-page/interfaces/agenzia.interface';

@Injectable({
  providedIn: 'root', // Assicurati che il servizio sia disponibile in tutta l'applicazione
})
export class PrivacyService {
 private _profile$: Observable<IRemoteProfile> = this._projectService.getProfile();

  private readonly WT_NETWORK_CODES = [
    '19304', '21364', '18347', '18268', '18278', '21388', '0255',
    '2643', '2469', '2434', '1768', '2541', '2374', '2399',
    '2375', '2350', '2362', '2376', '19303', '2652'
  ];

  constructor(
    private _cmsService: CmsService, // Inietta i servizi necessari
    private _templatesService: TemplatesService,
    private _compilerService: CompilerService,
    private _projectService: ProjectService
  ) {}

  // tslint:disable-next-line:typedef
  public loadPrivacyBookingBody(privacyForAgency: boolean = false, isPreventivo: boolean, isSellOrOption: boolean, agency: Agenzia) {
    return this._cmsService.siteUrl$.pipe(
      mergeMap((siteUrl) => {
        const url = siteUrl ?? this._projectService.parentUrl;
        const template = this.resolveTemplate(url, privacyForAgency, isPreventivo, isSellOrOption, agency);

        if (!template) {
          throw new Error('Template non definito per la combinazione fornita.');
        }

/*      const template: TemplateTypes = (this._templatesService.isIstitutional(url) && !privacyForAgency) ?
        TemplateTypes.WTISTITUZIONALE_BOOKING : TemplateTypes.GEO_PRIVACY_BOOKING;*/

        return forkJoin([
          this._templatesService.getTemplate(template),
          this._profile$
        ]);
      }),
      map(e => this._compilerService.compile(e[0], e[1]))
    );
  }

  private resolveTemplate(
    url: string,
    privacyForAgency: boolean,
    isPreventivo: boolean,
    isSellOrOption: boolean,
    agency?: Agenzia
  ): TemplateTypes | null {

    const isIstitutional = this._templatesService.isIstitutional(url);
    const isWtGroup = this._templatesService.isWtStoreOrWtShop(url);
    const isWelecomeTravel = this._templatesService.isVacanzeWelcomeTravel(url);

    // Caso 1: Dal sito Welcome Travel con alcune agenzie discriminate
    if (isWelecomeTravel && this.WT_NETWORK_CODES.includes(agency.externalAgencyId)) {
      if (isPreventivo) { return TemplateTypes.WTG_PREVENTIVO; }
      if (isSellOrOption) { return TemplateTypes.WTG_SELL_OR_OPTION; }
      return TemplateTypes.WTISTITUZIONALE_BOOKING;
    }

    // Caso 2: Welcome Travel Group (istituzionale con URL WTG), risultato uguale al precedente,
    // ma discriminato per leggibilità
    if (isIstitutional && isWtGroup) {
      if (isPreventivo) { return TemplateTypes.WTG_PREVENTIVO; }
      if (isSellOrOption) { return TemplateTypes.WTG_SELL_OR_OPTION; }
      return TemplateTypes.WTISTITUZIONALE_BOOKING;
    }

    // Caso 3: Istituzionale ma non WTG (es. agenzia su dominio istituzionale)
    if (isIstitutional && privacyForAgency) {
      if (isPreventivo) { return TemplateTypes.AGENCY_PREVENTIVO; }
      if (isSellOrOption) { return TemplateTypes.AGENCY_SELL_OR_OPTION; }
    }

    // Caso 4: Non istituzionale (dominio agenzia classico)
    if (!isIstitutional) {
      if (isPreventivo) { return TemplateTypes.AGENCY_PREVENTIVO; }
      if (isSellOrOption) { return TemplateTypes.AGENCY_SELL_OR_OPTION; }
    }

    return null;
  }
}
